import { WORK_RIGHTS_UK_FIELDS, WORK_RIGHTS_UK_VALUES } from '@/core/field-names';
import storeModule from '@/store';
import { isEmptyObject } from '@/lib/is-empty-object';

export function cleanRightToWork(document, store = storeModule) {
  const workRightsMap = document.fields.reduce((prev, field) => {
    return {
      ...prev,
      [field.name]: field,
    };
  }, {});

  let fieldName = WORK_RIGHTS_UK_FIELDS.BIRTH_CERTIFICATE;
  if (
    workRightsMap[WORK_RIGHTS_UK_FIELDS.RESIDENCY]?.value ===
    WORK_RIGHTS_UK_VALUES.BRITISH_IRISH
  ) {
    fieldName = WORK_RIGHTS_UK_FIELDS.SUPPORTING_DOCUMENTS;
  }

  const fieldId = workRightsMap[fieldName].id;

  if (
    workRightsMap[fieldName].fileValue &&
    !isEmptyObject(workRightsMap[fieldName].fileValue)
  ) {
    const payload = {
      fileId: store.getters['FileHandler/getFileId']({ fieldName, fieldId }),
      fieldId,
      onboardingId: store.state.onboardingId,
    };
    store.dispatch('FileHandler/delete', payload);
    workRightsMap[fieldName].value = null;
    workRightsMap[fieldName].valueObj = {};
    workRightsMap[fieldName].fileValue = {};
  }

  return document;
}
